import { MainShopProduct } from "@/core/models/shop-product-model";
import { getProductsByCategory } from "@/core/lib/api/main/main-shop-product";
import PaginationLinks from "@/components/shared/PaginationLinks";
import { getDictionaryServer } from "@/core/lib/dictionary";
import ProductCard from "./ProductCard";

export default async function ProductsList({
  slug,
  page,
  perPage,
  sort_by,
  is_available,
  search,
  tag
}: {
  slug: string;
  page: number;
  is_available: number;
  sort_by: string
  perPage: number;
  search: string
  tag: string
}) {
  const { dictionary } = await getDictionaryServer()

  const products = await getProductsByCategory(slug, page, perPage, search, tag, sort_by, is_available);
  const items: MainShopProduct[] = products?.data?.data ?? [];

  if (items.length === 0) {
    return (
      <p className="text-center p-4 text-primary-600">{dictionary.forms.linkSelector.noProductsFound}</p>
    )
  }

  return (
    <div className="space-y-8 pb-10">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {items.map((product, index) => (
          <ProductCard key={product.id} product={product} priority={index < 4} />
        ))}
      </div>
      <PaginationLinks
        currentPage={products?.data?.current_page ?? page}
        lastPage={products?.data?.last_page ?? page}
        perPage={perPage}
        extraParams={{ search, tag, sort_by, is_available }}
      />
    </div>
  );
}
